<template>
  <div class="sidebar-inner">
    <nav class="sidebar-nav">
      <button
        v-for="item in menuItems"
        :key="item.key"
        :class="['menu-item', { 
          'menu-item-active': isActive(item.page),
          'menu-item-disabled': item.isDisabled
        }]"
        @click="handleMenuClick(item.page, item.labelGroup)"
      >
        <component :is="item.icon" :size="16" class="menu-icon" />
        <span class="menu-label">{{ item.label }}</span>
        <div v-if="isActive(item.page)" class="menu-indicator"></div>
      </button>
    </nav>

    <div class="sidebar-footer">
      <button class="menu-item sidebar-settings" type="button" @click="goToAdmin">
        <Settings :size="16" class="menu-icon" />
        <span class="menu-label">设置</span>
      </button>
    </div>
  </div>
</template>

<script>
import {
  Building2,
  FileText,
  Gavel,
  Microscope,
  ClipboardList,
  Stethoscope,
  Settings,
} from 'lucide-vue-next'
import { getEnabledMenus, PAGE_CONFIG_UPDATED } from '@/services/pageConfigService'

const ICON_MAP = {
  Building2,
  FileText,
  Gavel,
  Microscope,
  ClipboardList,
  Stethoscope,
}

const FALLBACK_MENUS = [
  { key: 'registry', label: '器械注册查询', icon: 'ClipboardList', page: 'registry', labelGroup: 5 },
  { key: 'clinical', label: '临床研究', icon: 'Stethoscope', page: 'clinical', labelGroup: 6 },
  { key: 'tech', label: '前沿技术', icon: 'Microscope', page: 'tech', labelGroup: 4 },
  { key: 'dashboard', label: '国家政策', icon: 'FileText', page: 'dashboard', labelGroup: 2 },
  { key: 'enterprise', label: '企业/市场端', icon: 'Building2', page: 'enterprise', labelGroup: 1 },
  { key: 'bidding', label: '招投标信息', icon: 'Gavel', page: 'bidding', labelGroup: 3 },
]

export default {
  name: 'AppSidebarContent',
  components: { ...ICON_MAP, Settings },
  emits: ['menu-click'],
  data() {
    return {
      configVersion: 0,
    }
  },
  computed: {
    menuItems() {
      this.configVersion
      const dynamic = getEnabledMenus()
      if (dynamic?.length) {
        return dynamic.map((m) => ({
          key: m.page,
          label: m.label,
          icon: m.icon || 'FileText',
          page: m.page,
          labelGroup: m.labelGroup,
          isDisabled: false,
        }))
      }
      return FALLBACK_MENUS
    },
    currentLabelGroup() {
      return Number(this.$route.params.labelGroup)
    },
  },
  mounted() {
    this.onConfigUpdated = () => { this.configVersion += 1 }
    window.addEventListener(PAGE_CONFIG_UPDATED, this.onConfigUpdated)
  },
  beforeUnmount() {
    window.removeEventListener(PAGE_CONFIG_UPDATED, this.onConfigUpdated)
  },
  methods: {
    isActive(page) {
      const labelGroupMap = {
        enterprise: 1,
        dashboard: 2,
        bidding: 3,
        tech: 4,
        registry: 5,
        clinical: 6
      }
      return this.currentLabelGroup === labelGroupMap[page]
    },
    handleMenuClick(page, labelGroup) {
      this.$emit('menu-click')
      this.$router.push({
        name: 'Dashboard',
        params: { labelGroup }
      })
    },
    goToAdmin() {
      this.$emit('menu-click')
      this.$router.push('/admin/crawlconfig')
    },
  }
}
</script>

<style scoped>
.sidebar-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
}

.sidebar-nav {
  flex: 1;
  overflow-y: auto;
  padding: 16px 0;
}

.sidebar-footer {
  flex-shrink: 0;
  border-top: 1px solid #f0f0f0;
  padding: 8px 0;
}

.sidebar-settings .menu-label,
.sidebar-settings .menu-icon {
  color: rgba(0, 0, 0, 0.65);
}

.sidebar-settings:hover {
  background-color: #fafafa;
}

.sidebar-settings:hover .menu-label,
.sidebar-settings:hover .menu-icon {
  color: #1890ff;
}

.menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  position: relative;
  transition: all 0.3s;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  text-align: left;
  line-height: 1.5;
}

.menu-item:hover {
  background-color: #fafafa;
}

.menu-item-disabled {
  opacity: 0.5;
  color: rgba(0, 0, 0, 0.25) !important;
}

.menu-item-disabled .menu-label {
  color: rgba(0, 0, 0, 0.25) !important;
}

.menu-item-disabled .menu-icon {
  color: rgba(0, 0, 0, 0.25) !important;
}

.menu-item-disabled:hover {
  background-color: #fafafa;
}

.menu-item-active {
  background-color: #e6f7ff;
  color: #1890ff;
}

.menu-item-active .menu-label {
  color: #1890ff;
}

.menu-indicator {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #1890ff;
}

.menu-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-label {
  font-size: 14px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.85);
}
</style>
